import { render, staticRenderFns } from "./PrintLinkedCase.vue?vue&type=template&id=36aa88b9&"
import script from "./PrintLinkedCase.vue?vue&type=script&lang=js&"
export * from "./PrintLinkedCase.vue?vue&type=script&lang=js&"
import style0 from "./PrintLinkedCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrintLinkedCase.vue"
export default component.exports